import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslation } from '@modernloop/i18n';
import { Button } from '@mui/material';

import QueueModal from './QueueModal';

export const AddQueueModalOpenUrlParam = 'defaultAddQueueModalOpen';

const getUrlParam = (urlSearch: string, param: string) => {
  const params = new URLSearchParams(urlSearch);
  return params.get(param);
};

type Props = {
  disabled: boolean;
};

export const AddQueue: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { search } = useLocation();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect synchronizes local state from external inputs; prefer derived state when possible.
  useEffect(() => {
    const openFromurl = getUrlParam(search, AddQueueModalOpenUrlParam);
    if (openFromurl === 'true' && !disabled) {
      setOpen(true);
    }
  }, [search, disabled]);

  return (
    <>
      <Button variant="contained" disabled={disabled} color="primary" onClick={() => setOpen(true)}>
        {t('hiring-dashboard-settings-tasks:settings.tasks.queues.newQueue')}
      </Button>
      {open && (
        <QueueModal
          open={open}
          taskQueue={null}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
    </>
  );
};
